import React from 'react';

import { Col, Modal, Row } from 'react-bootstrap';
import { BsFillLightningFill } from 'react-icons/bs';
import { CancelButton, ConfirmButton } from '~/components/Buttons';
import {
  InputMaskCest,
  InputMoney,
  InputNumber,
  InputSelect,
  InputText,
} from '~/components/NovosInputs';
import Separator from '~/components/Separator';
import { useManutencaoFiscal } from '../../ManutencaoFiscalContext';
import { IpiCell, TaxesGrid } from './styles';

const colBaseStyle: React.CSSProperties = { flex: '1 1 120px', minWidth: 120 };

export const ModalEditNFItem: React.FC<{ num_item: number }> = ({
  num_item,
}) => {
  const {
    openModal,
    handleOpenModal,
    gtinsAtivos,
    tributacoesSelect,
    ncms,
    getValuesFiscal,
    handleAplicarItens,
    registerFiscal,
    controlFiscal,
    setValueFiscal,
    formStateFiscal,
    cfops,
  } = useManutencaoFiscal();

  return (
    <Modal
      key="modal"
      size="xl"
      onHide={() => handleOpenModal(false)}
      centered
      show={openModal}
    >
      <Modal.Header
        style={{
          paddingBottom: '0.5rem',
        }}
      >
        <Modal.Title>Editar Item: {num_item}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h3>{getValuesFiscal('descricao')}</h3>
        <Row style={{ alignItems: 'flex-end' }}>
          <Col md={3} sm={12}>
            <InputSelect
              label="GTIN"
              placeholder="Selecione..."
              name="cod_gtin"
              disabled={false}
              register={registerFiscal}
              options={gtinsAtivos}
              isError={!!formStateFiscal.errors.cod_gtin}
              control={controlFiscal}
              changeSelected={(selected: any) => {
                setValueFiscal('cod_gtin', selected);
              }}
            />
          </Col>
          <Col md={2} sm={12}>
            <InputSelect
              label="CFOP"
              placeholder="Selecione..."
              name="cfop"
              disabled={false}
              register={registerFiscal}
              options={cfops}
              isError={!!formStateFiscal.errors.cfop}
              control={controlFiscal}
              changeSelected={(selected: any) => {
                setValueFiscal('cfop', selected);
              }}
            />
          </Col>
          <Col md={7} sm={12}>
            <InputText
              label="Descrição"
              min={0}
              step={1}
              placeholder="Informe o numero de série"
              name="descricao"
              disabled={false}
              toLowerCase={false}
              register={registerFiscal}
              isError={!!formStateFiscal.errors.descricao}
              maxLength={100}
            />
          </Col>
        </Row>

        <Row style={{ alignItems: 'flex-end' }}>
          <Col md={4} sm={12}>
            <div>
              <InputSelect
                label="Tributação"
                placeholder="Selecione..."
                name="tributacao"
                disabled={false}
                listaHeight="200px"
                register={registerFiscal}
                options={tributacoesSelect}
                isError={!!formStateFiscal.errors.tributacao}
                control={controlFiscal}
                changeSelected={(selected: any) => {
                  setValueFiscal('tributacao', selected);
                }}
              />
            </div>
          </Col>
          <Col md={6} sm={12}>
            <InputSelect
              label="NCM"
              maxLength={50}
              placeholder="Selecione..."
              name="num_ncm"
              listaHeight="200px"
              disabled={false}
              register={registerFiscal}
              options={ncms}
              isError={!!formStateFiscal.errors.num_ncm}
              control={controlFiscal}
              changeSelected={(selected: any) => {
                setValueFiscal('num_ncm', selected);
              }}
            />
          </Col>
          <Col md={2} sm={12}>
            <InputMaskCest
              register={registerFiscal}
              label="CEST"
              name="num_cest"
              isError={!!formStateFiscal.errors.num_cest}
              control={controlFiscal}
            />
          </Col>
        </Row>
        <Row style={{ alignItems: 'flex-end' }}>
          <Col style={{ maxWidth: '90px' }} md={2} sm={12}>
            <InputText
              label="Embalagem"
              min={0}
              step={1}
              placeholder="Informe o numero de série"
              name="des_embalagem"
              disabled={false}
              caseInput="upper"
              toLowerCase={false}
              register={registerFiscal}
              isError={!!formStateFiscal.errors.des_embalagem}
              maxLength={5}
            />
          </Col>
          <Col md={2} sm={12}>
            <InputNumber
              label="Qtd. Emb."
              min={0}
              max={999}
              placeholder="Informe o numero de série"
              name="qtd_embalagem"
              disabled={false}
              register={registerFiscal}
              isError={!!formStateFiscal.errors.qtd_embalagem}
              maxLength={0}
            />
          </Col>
          <Col md={2} sm={12}>
            <InputNumber
              label="Qtd. Entrada"
              min={0}
              max={999}
              placeholder="Informe o numero de série"
              name="qtd_entrada"
              disabled={false}
              register={registerFiscal}
              isError={!!formStateFiscal.errors.qtd_entrada}
              maxLength={0}
            />
          </Col>
          <Col md={2} sm={12}>
            <InputNumber
              label="Qtd Total"
              min={0}
              max={999}
              step="1"
              placeholder="Informe o numero de série"
              name="qtd_total"
              disabled={false}
              register={registerFiscal}
              isError={!!formStateFiscal.errors.qtd_total}
              maxLength={0}
            />
          </Col>
          <Col md={2} sm={12}>
            <InputMoney
              label="Val. Total:"
              maxLength={10}
              min={0.0}
              placeholder="0,00"
              name="val_total"
              showIcon={false}
              disabled={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_total}
            />
          </Col>
          <Col style={{ maxWidth: '143.3px' }} md={2} sm={12}>
            <InputMoney
              label="Desconto:"
              maxLength={10}
              min={0}
              placeholder="0,00"
              name="val_desconto"
              disabled={false}
              showIcon={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_desconto}
            />
          </Col>
          <Col style={{ maxWidth: '143.3px' }} md={2} sm={12}>
            <InputMoney
              label="Acréscimo:"
              maxLength={10}
              min={0}
              placeholder="0,00"
              name="acrescimo"
              disabled={false}
              showIcon={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.acrescimo}
            />
          </Col>
        </Row>
        <TaxesGrid>
          <Col style={colBaseStyle}>
            <InputMoney
              label="BC ICMS OP:"
              maxLength={10}
              min={0}
              placeholder="0,000"
              decimals={3}
              name="val_bc_icms"
              disabled={false}
              showIcon={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_bc_icms}
            />
          </Col>

          <Col style={colBaseStyle}>
            <InputMoney
              label="ICMS OP:"
              maxLength={10}
              min={0}
              placeholder="0,00"
              name="val_icms_op"
              showIcon={false}
              disabled={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_icms_op}
            />
          </Col>

          <Col style={colBaseStyle}>
            <InputMoney
              label="Outros:"
              maxLength={10}
              min={0}
              placeholder="0,00"
              name="val_outros"
              showIcon={false}
              disabled={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_outros}
            />
          </Col>

          <Col style={colBaseStyle}>
            <InputMoney
              label="Isento:"
              maxLength={10}
              min={0}
              placeholder="0,00"
              name="val_isento"
              showIcon={false}
              disabled={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_isento}
            />
          </Col>

          <IpiCell style={colBaseStyle} dividerHeight={50}>
            <InputMoney
              label="BC ST:"
              maxLength={10}
              min={0}
              placeholder="0,000"
              decimals={3}
              name="val_bc_st"
              disabled={false}
              showIcon={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_bc_st}
            />
          </IpiCell>

          <Col
            style={{
              ...colBaseStyle,
              maxWidth: '100px',
            }}
          >
            <InputMoney
              label="ST:"
              maxLength={10}
              min={0}
              placeholder="0,000"
              decimals={3}
              name="st"
              disabled={false}
              showIcon={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.st}
            />
          </Col>

          <Col
            style={{
              ...colBaseStyle,
              maxWidth: '120px',
            }}
          >
            <InputMoney
              label="FCP ST.:"
              maxLength={10}
              min={0}
              placeholder="0,000"
              decimals={3}
              name="val_fcp_st"
              disabled={false}
              showIcon={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_fcp_st}
            />
          </Col>

          <IpiCell
            style={{
              ...colBaseStyle,
              maxWidth: '120px',
            }}
            dividerHeight={50}
          >
            <InputMoney
              label="IPI:"
              maxLength={10}
              min={0}
              placeholder="0,000"
              decimals={3}
              name="val_ipi"
              disabled={false}
              showIcon={false}
              register={registerFiscal}
              control={controlFiscal}
              isError={!!formStateFiscal.errors.val_ipi}
            />
          </IpiCell>
        </TaxesGrid>
        <Separator labelText="" />
        <Row style={{ marginTop: '10px', marginBottom: '10px' }}>
          <Col style={{ height: '10px' }} md={6} sm={12}>
            {' '}
          </Col>
          <Col
            style={{
              display: 'flex',
              paddingLeft: '10px',
              justifyContent: 'flex-end',
            }}
            md={6}
            sm={12}
          >
            <CancelButton
              onClick={() => {
                handleOpenModal(false);
              }}
            >
              CANCELAR
            </CancelButton>
            <ConfirmButton
              onClick={() => {
                handleAplicarItens();
              }}
            >
              <BsFillLightningFill fontSize="20px" color="#fff" />
              APLICAR
            </ConfirmButton>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
